import { useI18n } from 'vue-i18n'

export function useTranslate() {
  const { t } = useI18n()
  const getTranslation = (key) => t(key)
  
  return { t, getTranslation }
}